import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";

const { Option } = Select;

const FixedAssetInput = (props: any) => {
  const { value, placeholder, onChange } = props;
  const { projects, assets_filter } = useSelector(
    (state: RootState) => state.auth
  );
  const defaultPagination = 50;
  const [page, setPage] = useState(0);
  const [searching, setSearching] = useState(false);
  const [pagination, setPagination] = useState(true);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  let timeout;

  const getAssets = (pageNumber, search = "") => {
    setPage(pageNumber);
    setSearching(true);
    const requestData = {
      objectType: "asset",
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@userType:{'fixedAsset'}@serviceId:{'${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "TIMEOUT 1000",
        },
        load: {
          objectId: "$.objectId",
          persistent: "$.persistent",
          latitude: "$.persistent.static.fixedAsset.location.coordinates.lat",
          longitude: "$.persistent.static.fixedAsset.location.coordinates.long",
        },
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {
        pagination: {
          offset: pageNumber * defaultPagination,
          limit: defaultPagination,
        },
      },
      filter: {
        expression: "exists(@latitude) && @latitude !== 0",
      },
      anyStatus: false,
    };
    dispatch({
      type: "GET_MAP_PLACES",
      payload: requestData,
    });
    setSearching(true);
  };
  useEffect(() => {
    if (assets_filter) {
      setSearching(false);
      const opts = assets_filter
        ?.map((x) => {
          return {
            id: x.id,
            name: x.name,
            obj: x,
          };
        })
        .filter((x) => {
          return !options.find((y) => {
            return x.id === y.id;
          });
        });
      setOptions([...options, ...opts]);
      if (opts.length === 0) {
        setPagination(false);
      }
    }
  }, [assets_filter]);

  return (
    <Select
      showSearch
      value={value?.id}
      className="w-full"
      placeholder={placeholder}
      onChange={(value) => {
        const asset = options.find((x) => {
          return x.id === value;
        });
        onChange({
          id: value,
          type: "fixed-asset",
          asset: asset.obj,
        });
      }}
      loading={searching}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onFocus={() => {
        if ((assets_filter?.length ?? 0) === 0) getAssets(0);
      }}
      onSearch={(search) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          if (search && search !== "") {
            getAssets(0, search);
            setPagination(false);
          } else getAssets(0);
        }, 500);
      }}
      onPopupScroll={(e: any) => {
        e.persist();
        let target = e.target;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
          if (pagination) {
            getAssets(page + 1);
          }
        }
      }}
    >
      {options?.map((option, index) => (
        <Option key={index} value={option.id}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};

export default FixedAssetInput;
